import { LinkButton } from "@digipost/dds-buttons-react";
import { useLanguage } from "@digipost/translate";
import React from "react";

import styles from "./Logo.module.less";

const Logo: React.FC = () => {
  const { language } = useLanguage();
  return (
    <LinkButton
      as="a"
      href={"/" + (language === "nb" ? "" : language)}
      className={styles.headerLogoLink}
    >
      <img
        src={"/innlogging/images/logo/digipost_logo_stor.svg"}
        alt={"Logo: Digipost"}
        className={styles.logoDigipost}
      />
      <img
        src={"/innlogging/images/logo/digipost_logo_liten.svg"}
        alt={"Logo: Digipost"}
        className={styles.logoDigipostMobil}
      />
    </LinkButton>
  );
};

export default Logo;
